import { isEmpty } from 'lodash';
import { InitiateAnalyticsCheck } from './InitiateAnalyticsCheck';
import { GoogleAnalytics4Tags } from './GoogleAnalytics4Tags';
import { PARTNER_ID, REFERRAL_TYPE_GA4 } from '../Constants/Constants';

declare const window: any;

type eventObject = {
    event: string,
    event_name: string,
    click_item?: string,
    load_item?: string,
    Selected_item?: string,
}

function triggerTag(eventAction: string, eventModule: string | undefined, eventLabel: any) {
    window.dataLayer = window.dataLayer || [];

    let eventActionValue: string = eventAction;

    switch (eventModule) {
        case PARTNER_ID:
            eventActionValue = `${eventAction}User`;
            break;
        case REFERRAL_TYPE_GA4:
            eventActionValue = `${eventAction}ReferralType`;
    }

    const eventActionKey = GoogleAnalytics4Tags.eventActionKey[eventActionValue];

    let eventObject: eventObject = {
        event: '',
        event_name: ''
    };

    eventObject.event = eventAction;
    eventObject.event_name = eventModule as string;
    eventObject[eventActionKey] = eventLabel;

    console.log("eventObject", JSON.stringify(eventObject));
    window.dataLayer.push(eventObject);
}

export function TriggerGoogleAnalytics4Tag(eventModule: string | undefined, eventAction: string, eventLabel: string, data: object | string = '') {
    if (data && !isEmpty(data)) {
        let currentDataKey = Object.keys(data)[0],
            currentDataValue = data[currentDataKey];

        eventLabel = eventLabel.replace('{' + currentDataKey + '}', currentDataValue);
    }

    InitiateAnalyticsCheck(window);

    if (eventAction === GoogleAnalytics4Tags.eventAction.load) {
        window.isAnalyticsLoaded.then((message) => {
            if (message === "GA-LOADED") {
                triggerTag(eventAction, eventModule, eventLabel);
            }
        }).catch((message) => { console.log("In catch", message) });
    } else if (window.ga && window.ga.loaded) {
        window.dataLayer = window.dataLayer || [];
        triggerTag(eventAction, eventModule, eventLabel)
    }
}
